import { Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { videoInfoPropTypes } from '../../../types/videoInfo';
import { videoReferencePropTypes } from '../../../types/videoReference';
import {
  getFormattedDateTime,
  getMatchDateAndTime,
  getMatchName,
} from '../../../utils/alignment-data';
import { getCameraAngleFromTrack } from '../../../utils/track';
import { EMPTY_CELL_VALUE } from '../../../constants/tableRows';

function ReviewOffsetsStepTableRows({ videoInfo, videoReference }) {
  const intl = useIntl();

  return (
    <>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Sport',
            id: '96faa',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {videoReference?.sport}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Match',
            id: '6da89',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {getMatchName(videoInfo, intl) || EMPTY_CELL_VALUE}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Match Id',
            id: 'd7b6f',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {videoReference?.matchId}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Period',
            id: '19016',
          })}
        </Table.DataCell>

        <Table.DataCell $textAlign="left">
          {videoReference?.period}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Competition',
            id: '1bded',
          })}
        </Table.DataCell>

        <Table.DataCell $textAlign="left">
          {videoInfo?.competition || EMPTY_CELL_VALUE}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Match Date & Time',
            id: 'c8c8b',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {getMatchDateAndTime(videoInfo, intl)}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Video Angle',
            id: 'c1fc4',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {getCameraAngleFromTrack(intl)[videoReference?.track] ||
            EMPTY_CELL_VALUE}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Version',
            id: '34b6c',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {videoReference?.version}
        </Table.DataCell>
      </Table.Row>
      <Table.Row>
        <Table.DataCell $textAlign="left">
          {intl.formatMessage({
            defaultMessage: 'Events Last Updated',
            id: 'f8a53',
          })}
        </Table.DataCell>
        <Table.DataCell $textAlign="left">
          {getFormattedDateTime(videoInfo?.eventsUpdated, intl) ||
            EMPTY_CELL_VALUE}
        </Table.DataCell>
      </Table.Row>
    </>
  );
}

ReviewOffsetsStepTableRows.propTypes = {
  videoInfo: PropTypes.shape(videoInfoPropTypes).isRequired,
  videoReference: PropTypes.shape(videoReferencePropTypes).isRequired,
};

export default ReviewOffsetsStepTableRows;
